import { ReactNode } from 'react';

import { CardLink } from '@components/atoms/CardLink/CardLink';
import { PlaceholderCard } from '@components/atoms/PlaceholderCard/PlaceholderCard';
import { StatsFrame } from '@components/atoms/StatsFrame/StatsFrame';

import {
    ActionWrapper,
    StatisticHeader,
    StatsFramesWrapper,
} from './StatisticsCards.styled';

interface StatisticItem {
    label: ReactNode;
    value: number;
}

interface ActionLinkProps {
    href: string;
    text: string;
}

export interface StatisticsCardProps {
    actionLink: ActionLinkProps;
    description: string;
    hidden: boolean;
    loading: boolean;
    statistics: StatisticItem[];
    title: string;
}

export const StatisticsCard = ({
    actionLink,
    description,
    hidden,
    loading,
    statistics,
    title,
}: StatisticsCardProps) => {
    return (
        <PlaceholderCard hidden={hidden} minHeight={368}>
            <StatisticHeader>
                <PlaceholderCard.Title>{title}</PlaceholderCard.Title>
                <PlaceholderCard.Description>
                    {description}
                </PlaceholderCard.Description>
            </StatisticHeader>
            <StatsFramesWrapper>
                {statistics.map((item, index) => (
                    <StatsFrame key={index} loading={loading} {...item} />
                ))}
            </StatsFramesWrapper>
            <ActionWrapper>
                {actionLink && (
                    <CardLink href={actionLink.href}>
                        {actionLink.text}
                    </CardLink>
                )}
            </ActionWrapper>
        </PlaceholderCard>
    );
};
